const chineseRegex = /[\u4e00-\u9fa5]/;
export const useIsContainChinese = (str) => {
  if (!str) return false;
  return chineseRegex.test(str);
}